
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinars/whatsapp-healthcare",
      function () {
        return require("private-next-pages/webinars/whatsapp-healthcare.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinars/whatsapp-healthcare"])
      });
    }
  